module.exports = __webpack_public_path__ + "static/media/SherlockBonesBookCover.67225f1c.jpg";